import React from 'react';
import { logEventWithGroups } from '@cultureamp/amplitude';
import { Button } from '@kaizen/button';
import styles from './SubmitButtons.scss';

type Props = {
  surveyAggregateId: string;
  allowSaveAndExit: boolean;
  saveAndExitUrl: string;
  answeredHelperId: string;
  uiText: {
    saveAndExit: string;
    finish: string;
  };
};

export default ({
  surveyAggregateId,
  allowSaveAndExit,
  saveAndExitUrl,
  answeredHelperId,
  uiText,
}: Props): React$Element<string> => {
  const onSaveAndExitClick = () => {
    logEventWithGroups(
      'Survey Response Saved',
      {},
      { Survey: surveyAggregateId }
    );
  };

  return (
    <div className={styles.actionContainer}>
      {allowSaveAndExit && (
        <div className={styles.saveAndExitWrapper}>
          <Button
            onClick={onSaveAndExitClick}
            secondary
            href={saveAndExitUrl}
            label={uiText.saveAndExit}
          />
        </div>
      )}
      <input type="hidden" name="field" value="submit" />
      <Button
        primary
        type="submit"
        label={uiText.finish}
        data-automation-id="capture-submit"
        aria-describedby={answeredHelperId}
      />
    </div>
  );
};
